import { Box, IconButton, Menu, MenuItem } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { ArabicFlagSVG, EnglishFlagSVG } from "../icons";
import Vector from "../../assets/icons/Vector.png";
export default function Translation({ isMobile }) {
  const { i18n } = useTranslation();
  const { language, changeLanguage } = i18n;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          textAlign: "center",
          width: "40px",
        }}
      >
        <IconButton
          onClick={handleClick}
          size="small"
          aria-controls={open ? "account-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
        >
          <img src={Vector} alt="Frame" width={35} />
        </IconButton>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              mr: 1,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {/* Disabled English language for the next Version */}
        <MenuItem
          button="true"
          onClick={() => changeLanguage("en")}
          selected={language === "en"}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            gap: "7px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
              gap: "5px",
            }}
          >
            <Box sx={{ width: "15px", height: "15px" }}>
              <EnglishFlagSVG />
            </Box>
            <Box sx={{ fontSize: ".70em", pt: "2px" }}>EN</Box>
          </Box>
        </MenuItem>
        <MenuItem
          button="true"
          onClick={() => changeLanguage("ar")}
          selected={language === "ar"}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            gap: "7px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
              gap: "5px",
            }}
          >
            <Box sx={{ width: "15px", height: "15px" }}>
              <ArabicFlagSVG />
            </Box>
            <Box sx={{ fontSize: ".70em", pt: "2px" }}>AR</Box>
          </Box>
        </MenuItem>
      </Menu>
    </>
  );
}
